import {CustomCheckbox, CustomCheckboxProps} from './Checkbox.styled';

const Checkbox: React.FC<CustomCheckboxProps> = props => {
  return <CustomCheckbox {...props} />;
};

export default Checkbox;
